<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OySNya/images/9780983138365_cover.jpg?1684514922703" alt="This image is the cover for the book Vein of Love"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Vein of Love
      </h1>
      <p class="bookDescription body article font2">
        
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Pat Mestern
      </h2>
      
      
         <a class="authorURL body link" href="mestern.net" target="_blank">
      
              About Author
         </a>
         <br/>
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canterbury House Publishing
     </h2>
        
        
     <a class="publisherURL body link" href="https://www.canterburyhousepublishing.com/" target="_blank">
  
          About Publisher
     </a>
     <br/>
  
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?60ab585a